import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { ITranscript } from '@/api-client/autogenerated';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export async function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getInitials(name: string) {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
}

// Add CSS variables for the sidebar transition
export const addSidebarTransitionStyles = () => {
  const style = document.createElement('style');
  style.innerHTML = `
    .sidebar-transition {
      transition: width 0.3s ease-in-out;
    }
    .content-transition {
      transition: margin-left 0.3s ease-in-out;
    }
  `;
  document.head.appendChild(style);
};

export const insertSpacesInCamelCase = (str: string) => {
  return str.replace(/([a-z])([A-Z])/g, '$1 $2');
};

export const getTranscriptSlice = (
  transcript: ITranscript,
  startIdx: [number, number],
  endIdx: [number, number],
): ITranscript => {
  // Word transcript
  if (transcript.wordTranscript.length > 0) {
    const aux = transcript.wordTranscript.slice(startIdx[0], endIdx[0] + 1);
    const subTranscript = aux.map((p, i) => {
      if (aux.length === 1) return p.slice(startIdx[1], endIdx[1] + 1);
      if (i === 0) return p.slice(startIdx[1], p.length);
      if (i === aux.length - 1) return p.slice(0, endIdx[1] + 1);
      return p;
    });
    return {
      wordTranscript: subTranscript,
      speakerTranscript: [],
    };
  }

  // Speaker transcript
  const subTranscript = transcript.speakerTranscript.slice(startIdx[0], endIdx[0] + 1);
  return {
    wordTranscript: [],
    speakerTranscript: subTranscript,
  };
};
